<form [formGroup]="form">
    <!-- Edit Mode Table: viewMode >= 2 -->
    <table class="ham-table" *ngIf="viewMode >= 2">
        <!-- Header Row -->
        <thead>
            <tr>
                <th class="hamScaleCol" style="min-width: 400px">
                    <div class="header-content">
                        <ng-content></ng-content>
                        <span *ngIf="tableNumber"> {{ tableNumber + ' ' + selectedFliName }}</span>
                        <span *ngIf="!tableNumber"> {{ selectedFliName }}</span>
                    </div>
                </th>
                <th class="hamNumberCol300 currentYear" *ngIf="fxState !== 'display'">
                    {{ currentDate | dateLocale }}
                    <div class="fx-currency-sub" *ngIf="fxEnabled">{{ functionalCurrency }}</div>
                </th>
                <!-- FX (REV-21512): computed display-currency twin, read-only -->
                <th class="hamNumberCol300 currentYear fx-twin-column" *ngIf="fxState !== 'functional'">
                    {{ currentDate | dateLocale }}
                    <div class="fx-currency-sub">{{ displayCurrency }}</div>
                </th>
                <th class="hamNumberCol300 previousYear" *ngIf="fxState !== 'display'">
                    {{ previousDate | dateLocale }}
                    <div class="fx-currency-sub" *ngIf="fxEnabled">{{ functionalCurrency }}</div>
                </th>
                <th class="hamNumberCol300 previousYear fx-twin-column" *ngIf="fxState !== 'functional'">
                    {{ previousDate | dateLocale }}
                    <div class="fx-currency-sub">{{ displayCurrency }}</div>
                </th>
            </tr>
        </thead>

        <tbody formArrayName="dataSource">
            <tr *ngFor="let row of form.get('dataSource')?.controls; let i = index" [formGroupName]="i">
                <td class="hamScaleCol" style="min-width: 400px">
                    <input hamInput type="text" formControlName="accountName" disabled />
                </td>
                <td
                    *ngIf="fxState !== 'display'"
                    class="hamNumberCol300 currentYear"
                    [ngClass]="{
                        todoHighlight:
                            todoHighlight &&
                            (row?.value?.currentValue === '' ||
                                row?.value?.currentValue === '-' ||
                                row?.value?.currentValue === 0 ||
                                row?.value?.currentValue == null)
                    }"
                >
                    <input hamInput type="number" formControlName="currentValue" disabled />
                </td>
                <td *ngIf="fxState !== 'functional'" class="hamNumberCol300 currentYear fx-twin-column">
                    <input hamInput type="number" [formControl]="fxCellControl(row, 'cy')" disabled />
                </td>
                <td
                    *ngIf="fxState !== 'display'"
                    class="hamNumberCol300 previousYear"
                    [ngClass]="{
                        todoHighlight:
                            todoHighlight &&
                            (row?.value?.previousValue === '' ||
                                row?.value?.previousValue === '-' ||
                                row?.value?.previousValue === 0 ||
                                row?.value?.previousValue == null)
                    }"
                >
                    <input hamInput type="number" formControlName="previousValue" disabled />
                </td>
                <td *ngIf="fxState !== 'functional'" class="hamNumberCol300 previousYear fx-twin-column">
                    <input hamInput type="number" [formControl]="fxCellControl(row, 'py')" disabled />
                </td>
            </tr>
        </tbody>

        <tfoot>
            <tr [formGroup]="form.get('totalRow')">
                <td class="hamScaleCol" style="min-width: 400px">
                    <input
                        hamInput
                        type="text"
                        formControlName="accountName"
                        placeholder="{{ 'aumico_notes_table_with_form_total' | i18next }}"
                    />
                </td>
                <td class="hamNumberCol300 currentYear" *ngIf="fxState !== 'display'">
                    <input hamInput type="number" formControlName="currentValue" [readonly]="true" />
                </td>
                <td class="hamNumberCol300 currentYear fx-twin-column" *ngIf="fxState !== 'functional'">
                    <input hamInput type="number" [formControl]="fxTotalControl('cy')" [readonly]="true" />
                </td>
                <td class="hamNumberCol300 previousYear" *ngIf="fxState !== 'display'">
                    <input hamInput type="number" formControlName="previousValue" [readonly]="true" />
                </td>
                <td class="hamNumberCol300 previousYear fx-twin-column" *ngIf="fxState !== 'functional'">
                    <input hamInput type="number" [formControl]="fxTotalControl('py')" [readonly]="true" />
                </td>
            </tr>
        </tfoot>
    </table>

    <!-- Preview Mode Table: viewMode <= 1 -->
    <table class="ham-table previewMode" *ngIf="viewMode <= 1">
        <!-- Header Row -->
        <thead>
            <tr>
                <th class="hamScaleCol" style="min-width: 400px">
                    <span *ngIf="tableNumber"> {{ tableNumber + ' ' + selectedFliName }}</span>
                    <span *ngIf="!tableNumber"> {{ selectedFliName }}</span>
                </th>
                <th class="hamNumberCol300 currentYear" *ngIf="fxState !== 'display'">
                    <span>{{ currentDate | dateLocale }}</span>
                    <div class="fx-currency-sub" *ngIf="fxEnabled">{{ functionalCurrency }}</div>
                </th>
                <th class="hamNumberCol300 currentYear fx-twin-column" *ngIf="fxState !== 'functional'">
                    <span>{{ currentDate | dateLocale }}</span>
                    <div class="fx-currency-sub">{{ displayCurrency }}</div>
                </th>
                <th class="hamNumberCol300 previousYear" *ngIf="fxState !== 'display'">
                    <span>{{ previousDate | dateLocale }}</span>
                    <div class="fx-currency-sub" *ngIf="fxEnabled">{{ functionalCurrency }}</div>
                </th>
                <th class="hamNumberCol300 previousYear fx-twin-column" *ngIf="fxState !== 'functional'">
                    <span>{{ previousDate | dateLocale }}</span>
                    <div class="fx-currency-sub">{{ displayCurrency }}</div>
                </th>
            </tr>
        </thead>

        <tbody>
            <tr *ngFor="let row of form.get('dataSource')?.controls; let i = index">
                <td class="hamScaleCol" style="min-width: 400px">
                    <span>{{ row.value.accountName }}</span>
                </td>
                <td
                    *ngIf="fxState !== 'display'"
                    class="hamNumberCol300 currentYear"
                    [ngClass]="{
                        todoHighlight:
                            todoHighlight &&
                            (row?.value?.currentValue === '' ||
                                row?.value?.currentValue === '-' ||
                                row?.value?.currentValue === 0 ||
                                row?.value?.currentValue == null)
                    }"
                >
                    <span>{{ row.value.currentValue | finNumber }}</span>
                </td>
                <td *ngIf="fxState !== 'functional'" class="hamNumberCol300 currentYear fx-twin-column">
                    <span>{{ fxDisplayOf(row, 'cy') == null ? '' : (fxDisplayOf(row, 'cy') | finNumber) }}</span>
                </td>
                <td
                    *ngIf="fxState !== 'display'"
                    class="hamNumberCol300 previousYear"
                    [ngClass]="{
                        todoHighlight:
                            todoHighlight &&
                            (row?.value?.previousValue === '' ||
                                row?.value?.previousValue === '-' ||
                                row?.value?.previousValue === 0 ||
                                row?.value?.previousValue == null)
                    }"
                >
                    <span>{{ row.value.previousValue | finNumber }}</span>
                </td>
                <td *ngIf="fxState !== 'functional'" class="hamNumberCol300 previousYear fx-twin-column">
                    <span>{{ fxDisplayOf(row, 'py') == null ? '' : (fxDisplayOf(row, 'py') | finNumber) }}</span>
                </td>
            </tr>
        </tbody>

        <tfoot>
            <tr [formGroup]="form.get('totalRow')">
                <td class="hamScaleCol" style="min-width: 400px">
                    <span>{{ form.get('totalRow.accountName')?.value }}</span>
                </td>
                <td class="hamNumberCol300 currentYear" *ngIf="fxState !== 'display'">
                    <span>{{ form.get('totalRow.currentValue')?.value | finNumber }}</span>
                </td>
                <td class="hamNumberCol300 currentYear fx-twin-column" *ngIf="fxState !== 'functional'">
                    <span>{{ fxTotalCY == null ? '' : (fxTotalCY | finNumber) }}</span>
                </td>
                <td class="hamNumberCol300 previousYear" *ngIf="fxState !== 'display'">
                    <span>{{ form.get('totalRow.previousValue')?.value | finNumber }}</span>
                </td>
                <td class="hamNumberCol300 previousYear fx-twin-column" *ngIf="fxState !== 'functional'">
                    <span>{{ fxTotalPY == null ? '' : (fxTotalPY | finNumber) }}</span>
                </td>
            </tr>
        </tfoot>
    </table>
</form>

<!-- Footnote Section -->
<div class="footnote-section" *ngIf="hasFootnotes && viewMode === 2" [formGroup]="form">
    <label for="footnote">{{ 'aumico_notes_footnote_label' | i18next }}</label>
    <textarea
        hamInput
        [hideRemoveXButton]="true"
        [placeholder]="'aumico_notes_footnote_placeholder' | i18next"
        [formControl]="form.get('footnote')"
    ></textarea>
</div>
